import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import SecurityPermissionComponent from "go-security/components/Organization/Permission/Permission";
import { PermissionTabConfig } from "go-security/components/Organization/Permission/service/types";

const TranslationsInitialized = () => {
	const { t } = useTranslation();
	t("enums.permissions.value.PRODUCT_BASIC");
	t("enums.permissions.value.PRODUCT_EDIT");
	t("enums.permissions.value.PRODUCT_LINKS");
	t("enums.permissions.value.PRODUCT_MANAGE");
	t("enums.permissions.value.PURCHASE_ORDER_BASIC");
	t("enums.permissions.value.PURCHASE_ORDER_EDIT");
	t("enums.permissions.value.PURCHASE_ORDER_RECEIVE");
	t("enums.permissions.value.PURCHASE_ORDER_MANAGE");
	t("enums.permissions.value.PURCHASE_CORRECTION_BASIC");
	t("enums.permissions.value.PURCHASE_CORRECTION_EDIT");
	t("enums.permissions.value.PURCHASE_CORRECTION_MANAGE");
	t("enums.permissions.value.SALES_ORDER_BASIC");
	t("enums.permissions.value.SALES_ORDER_EDIT");
	t("enums.permissions.value.SALES_ORDER_SHIP");
	t("enums.permissions.value.SALES_ORDER_MANAGE");
	t("enums.permissions.value.SALES_RETURN_BASIC");
	t("enums.permissions.value.SALES_RETURN_EDIT");
	t("enums.permissions.value.SALES_RETURN_MANAGE");
	t("enums.permissions.value.TRANSFER_ORDER_BASIC");
	t("enums.permissions.value.TRANSFER_ORDER_EDIT");
	t("enums.permissions.value.TRANSFER_ORDER_MANAGE");
	t("enums.permissions.value.STOCK_ADJUSTMENT_BASIC");
	t("enums.permissions.value.STOCK_ADJUSTMENT_EDIT");
	t("enums.permissions.value.STOCK_ADJUSTMENT_MANAGE");
	t("enums.permissions.value.BUNDLE_BASIC");
	t("enums.permissions.value.BUNDLE_EDIT");
	t("enums.permissions.value.BUNDLE_MANAGE");
	t("enums.permissions.value.STOCKTAKING_BASIC");
	t("enums.permissions.value.STOCKTAKING_DRAFT");
	t("enums.permissions.value.STOCKTAKING_SUMMARY");
	t("enums.permissions.value.STOCKTAKING_CLOSE");
	t("enums.permissions.value.STOCKTAKING_MANAGE");
	t("enums.permissions.value.CONTACT_BASIC");
	t("enums.permissions.value.CONTACT_EDIT");
	t("enums.permissions.value.CONTACT_LINKS");
	t("enums.permissions.value.CONTACT_MANAGE");
	t("enums.permissions.value.REPORT");
	t("enums.permissions.value.INVOICE_BASIC");
	t("enums.permissions.value.INVOICE_DRAFT_EDIT");
	t("enums.permissions.value.INVOICE_CLOSE");
	t("enums.permissions.value.INVOICE_MANAGE");
	t("enums.permissions.value.COST_PREVIEW");
	t("enums.permissions.value.STOCK_STATES_PREVIEW");
	t("enums.permissions.value.SETTINGS");
	t("enums.permissions.value.MANAGE");
	t("enums.permissions.value.WAREHOUSE_API");
	t("enums.permissions.value.EDIT_NOT_OWNED_DOCUMENT");
	t("enums.permissions.value.VIEW_NOT_OWNED_DOCUMENT");
	t("enums.permissions.value.PURCHASE_ORDER_LOCK");
	t("enums.permissions.value.PURCHASE_ORDER_DELETE");
	t("enums.permissions.value.SALES_ORDER_LOCK");
	t("enums.permissions.value.SALES_ORDER_DELETE");
	t("enums.permissions.label.PRODUCT_BASIC");
	t("enums.permissions.label.PRODUCT_EDIT");
	t("enums.permissions.label.PRODUCT_LINKS");
	t("enums.permissions.label.PRODUCT_MANAGE");
	t("enums.permissions.label.PURCHASE_ORDER_BASIC");
	t("enums.permissions.label.PURCHASE_ORDER_EDIT");
	t("enums.permissions.label.PURCHASE_ORDER_RECEIVE");
	t("enums.permissions.label.PURCHASE_ORDER_MANAGE");
	t("enums.permissions.label.PURCHASE_CORRECTION_BASIC");
	t("enums.permissions.label.PURCHASE_CORRECTION_EDIT");
	t("enums.permissions.label.PURCHASE_CORRECTION_MANAGE");
	t("enums.permissions.label.SALES_ORDER_BASIC");
	t("enums.permissions.label.SALES_ORDER_EDIT");
	t("enums.permissions.label.SALES_ORDER_SHIP");
	t("enums.permissions.label.SALES_ORDER_MANAGE");
	t("enums.permissions.label.SALES_RETURN_BASIC");
	t("enums.permissions.label.SALES_RETURN_EDIT");
	t("enums.permissions.label.SALES_RETURN_MANAGE");
	t("enums.permissions.label.TRANSFER_ORDER_BASIC");
	t("enums.permissions.label.TRANSFER_ORDER_EDIT");
	t("enums.permissions.label.TRANSFER_ORDER_MANAGE");
	t("enums.permissions.label.STOCK_ADJUSTMENT_BASIC");
	t("enums.permissions.label.STOCK_ADJUSTMENT_EDIT");
	t("enums.permissions.label.STOCK_ADJUSTMENT_MANAGE");
	t("enums.permissions.label.BUNDLE_BASIC");
	t("enums.permissions.label.BUNDLE_EDIT");
	t("enums.permissions.label.BUNDLE_MANAGE");
	t("enums.permissions.label.STOCKTAKING_BASIC");
	t("enums.permissions.label.STOCKTAKING_DRAFT");
	t("enums.permissions.label.STOCKTAKING_SUMMARY");
	t("enums.permissions.label.STOCKTAKING_CLOSE");
	t("enums.permissions.label.STOCKTAKING_MANAGE");
	t("enums.permissions.label.VIEW_NOT_OWNED_DOCUMENT");
	t("enums.permissions.label.EDIT_NOT_OWNED_DOCUMENT");
	t("enums.permissions.label.CONTACT_BASIC");
	t("enums.permissions.label.CONTACT_EDIT");
	t("enums.permissions.label.CONTACT_LINKS");
	t("enums.permissions.label.CONTACT_MANAGE");
	t("enums.permissions.label.REPORT");
	t("enums.permissions.label.INVOICE_BASIC");
	t("enums.permissions.label.INVOICE_DRAFT_EDIT");
	t("enums.permissions.label.INVOICE_CLOSE");
	t("enums.permissions.label.INVOICE_MANAGE");
	t("enums.permissions.label.COST_PREVIEW");
	t("enums.permissions.label.STOCK_STATES_PREVIEW");
	t("enums.permissions.label.SETTINGS");
	t("enums.permissions.label.MANAGE");
	t("enums.permissions.label.WAREHOUSE_API");
	t("enums.permissions.label.PURCHASE_ORDER_LOCK");
	t("enums.permissions.label.PURCHASE_ORDER_DELETE");
	t("enums.permissions.label.SALES_ORDER_LOCK");
	t("enums.permissions.label.SALES_ORDER_DELETE");
};

const OrganizationSettingsPermissionsPage = () => {
	const { t } = useTranslation();
	const configs: PermissionTabConfig[] = [
		{
			id: "permissions",
			permissionLabelTranslationKey: "enums.permissions.label",
			permissionValueTranslationKey: "enums.permissions.value",
			title: t("modules.settings.field.permissions.title"),
		},
	];

	return (
		<div className="content">
			<SecurityPermissionComponent permissionTabConfigs={configs} />
		</div>
	);
};
export default OrganizationSettingsPermissionsPage;
